import { WARNING_SETTINGS_MAP } from '../constants/EventWarningTypes';

export const getEventWarningWithScope = (warningTypes, warningScope) => {
  return warningTypes?.find(
    warningType => WARNING_SETTINGS_MAP.get(warningType).scope === warningScope
  );
};
